import {Component, Input, OnInit} from '@angular/core';
import {Model} from '../../app.model';
import {AutorunComponent} from '@myshared/autorun.component';
import {AuthService} from '../../auth/auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: [],
    standalone: false
})
export class UserMenuComponent extends AutorunComponent implements OnInit {

  @Input()
  public name: string;

  public isUserInCompany: boolean;
  public isAuthorized: boolean;
  public isAdmin: boolean;


  constructor(
    private m: Model,
    private router: Router,
    private authService: AuthService,
  ) { super(); }


  ngOnInit() {
    this.autorun(() => {
      this.isUserInCompany = this.m.account.isInCompany ?? false;
      this.isAuthorized = this.m.account.isAuthorized;
      this.isAdmin = this.m.account.isMypascomAdmin;
    });
  }

  public logout() {
    this.authService.logout();
  }

  public get accountManagerUrl() {
    return this.authService.oidcAuthority + '/account/';
  }

  public openSettings() {
    this.router.navigate(['/company', 'contacts', this.m.account.currentUser.id]);
  }

  public openCompany() {
    this.router.navigate(['/company', 'details']);
  }
}
